export default {
  checkout: {},
  products: [],
  global: {
    header: [
      {
        title: 'A New Wearable',
        inSlider: true,
        id: 'a-new-wearable',
        order: 1,
        subtitle: 'high tech wearable / bone conduction technology',
        handNumber: 1
      },
      {
        title: 'Experience',
        inSlider: true,
        id: 'experience',
        order: 2,
        subtitle: 'sound transmission / multimodal interface / gesture recognition',
        handNumber: 2
      },
      {
        title: 'Paymenst',
        inSlider: true,
        id: 'payments',
        order: 3,
        subtitle: 'secure transaction / easy utilization / fast payment',
        handNumber: 3
      },
      {
        title: 'Fitness',
        inSlider: true,
        id: 'fitness',
        order: 4,
        subtitle: 'performance / sleep monitoring / navigation',
        handNumber: 4
      },
      {
        title: 'Tech Features',
        inSlider: false,
        id: 'tech-features',
        order: 5,
        subtitle: '',
        handNumber: -1
      },
      {
        title: 'About us',
        inSlider: false,
        id: 'about-us',
        subtitle: '',
        order: 6,
        handNumber: -1
      },
      {
        title: 'Contact Us',
        inSlider: false,
        id: 'contact-us',
        subtitle: '',
        order: 7,
        handNumber: -1
      }
    ],
    newsletter: {
      error: {
        email: 'Incorrect email',
      },
      placeholder: {
        email: 'Insert your email',
      },
      thxMsg: 'Thanks for subscribing our newsletter!',
    }
  },
  transition: {},
  scrollbar: null,
  isMenuOpen: false,
  isCartOpen: false,
  isInTransition: false,
  enableSlider: true,
  isMenuInTransition: false
}



// WEBPACK FOOTER //
// ./src/store/state.js